module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/moduleHeader/img/summer-body__600f878d50fe054da1d3379447c61994.png";